import { Tooltip } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTooltip = styled(Tooltip)`
  all: unset;
  white-space: nowrap;
`;
